<ng-container *transloco="let t">
  <!-- Footer Section -->
  <footer class="footer-section">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-logo-section">
          <div class="footer-logo">
            <img
              src="assets/icons/mzic-logo-name.svg"
              alt="MZIC"
              class="logo-image" />
          </div>
        </div>

        <div class="footer-links-section">
          <div class="footer-column">
            <h3 class="footer-title">{{ t('lang.footer.company.title') }}</h3>
            <ul class="footer-links">
              <li>
                <a (click)="goToAboutMzic()" class="footer-link">
                  {{ t('lang.footer.company.aboutMzic') }}
                </a>
              </li>
              <li>
                <a
                  [href]="footerLinks.forArtists"
                  class="footer-link"
                  target="_blank">
                  {{ t('lang.footer.company.forArtists') }}
                </a>
              </li>
              <li>
                <a (click)="goToContact()" class="footer-link">
                  {{ t('lang.footer.company.contact') }}
                </a>
              </li>
            </ul>
          </div>

          <div class="footer-column">
            <h3 class="footer-title">{{ t('lang.footer.legal.title') }}</h3>
            <ul class="footer-links">
              <li>
                <a
                  [href]="footerLinks.termsOfUse"
                  class="footer-link"
                  target="_blank">
                  {{ t('lang.footer.legal.termsOfUse') }}
                </a>
              </li>
              <li>
                <a
                  [href]="footerLinks.privacyPolicy"
                  class="footer-link"
                  target="_blank">
                  {{ t('lang.footer.legal.privacyPolicy') }}
                </a>
              </li>
            </ul>
          </div>

          <div class="footer-column app-column">
            <h3 class="footer-title">
              {{ t('lang.footer.downloadApp.title') }}
            </h3>
            <div class="app-buttons">
              <a [href]="playStoreUrl" target="_blank" class="app-button">
                <img
                  [src]="googlePlayDownload"
                  [alt]="t('lang.appDownload.googlePlayAlt')"
                  class="app-badge" />
              </a>
              <a [href]="appStoreUrl" target="_blank" class="app-button">
                <img
                  [src]="appStoreDownload"
                  [alt]="t('lang.appDownload.appStoreAlt')"
                  class="app-badge" />
              </a>
            </div>
          </div>
        </div>

        <div class="footer-social">
          <a
            [href]="socialLinks.instagram"
            class="social-link"
            aria-label="Instagram"
            target="_blank">
            <img
              src="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-instagram-white.svg"
              alt="Instagram"
              width="24"
              height="24" />
          </a>
          <a
            [href]="socialLinks.youtube"
            class="social-link"
            aria-label="YouTube"
            target="_blank">
            <img
              src="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-youtube-white.svg"
              alt="YouTube"
              width="24"
              height="24" />
          </a>
          <a
            [href]="socialLinks.spotify"
            class="social-link"
            aria-label="Spotify"
            target="_blank">
            <img
              src="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-spotify-white.svg"
              alt="Spotify"
              width="24"
              height="24" />
          </a>
          <a
            [href]="socialLinks.linkedin"
            class="social-link"
            aria-label="LinkedIn"
            target="_blank">
            <img
              src="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-linkedin-white.svg"
              alt="LinkedIn"
              width="24"
              height="24" />
          </a>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-disclaimer">
          <p class="disclaimer-text">
            {{ t('lang.footer.disclaimer') }}
          </p>

          <br />

          <p class="disclaimer-text">
            {{ t('lang.footer.disclaimer2') }}
          </p>
        </div>

        <div class="footer-address">
          <div class="address-info">
            <span class="address">
              Av. João Jorge Saad, 305 – Vila Progredior, São Paulo – SP,
              05618-000.
            </span>
          </div>
          <div class="company-info">
            <span class="company">
              © 2025 MZIC Brasil S.A. 60.975.631/0001-85
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</ng-container>
